/**
 * @generated SignedSource<<c9a6f14ff2b4e946e3d2692928031a57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionTopContentsCollection$data = {
  readonly advertZone: string | null | undefined;
  readonly entityId: string;
  readonly " $fragmentType": "topicCollectionTopContentsCollection";
};
export type topicCollectionTopContentsCollection$key = {
  readonly " $data"?: topicCollectionTopContentsCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionTopContentsCollection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionTopContentsCollection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "version",
          "value": 2
        }
      ],
      "kind": "ScalarField",
      "name": "advertZone",
      "storageKey": "advertZone(version:2)"
    }
  ],
  "type": "Collection",
  "abstractKey": null
};

(node as any).hash = "2cb8bb59830fca10472d3a29198c36c3";

export default node;
